import React from "react";
import { Link } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import { useShop } from "../context/ShopContext";
import { useLocale } from "../context/LocaleContext";
import { formatPrice } from "../mock";
import { toast } from "sonner";

const ProductCard = ({ product }) => {
  const { lang, t, addToCart } = useShop();
  const { lp } = useLocale();
  const href = lp(`/product/${product.slug}`, product.slug_en);

  const handleAdd = (e) => {
    e.preventDefault();
    addToCart(product, 1);
    toast.success(t("addedToCart"), { description: product.name[lang] });
  };

  return (
    <div className="idm-product-card" data-testid={`product-card-${product.slug}`}>
      <Link to={href} className="idm-product-img-wrap">
        {product.onSale && <span className="idm-sale-badge">{t("sale")}</span>}
        <img src={product.image} alt={product.name[lang]} loading="lazy" />
        <div className="idm-product-hover">
          <button
            className="idm-add-btn"
            onClick={handleAdd}
            data-testid={`add-to-cart-${product.slug}`}
          >
            <ShoppingCart size={15} />
            {t("addToCart")}
          </button>
        </div>
      </Link>
      <div className="idm-product-info">
        <Link to={href}>
          <h3 className="idm-product-title">{product.name[lang]}</h3>
        </Link>
        <div className="idm-product-price">
          {product.onSale && (
            <span className="idm-price-old">{formatPrice(product.regularPrice)}</span>
          )}
          <span className="idm-price">{formatPrice(product.price)}</span>
          {product.priceSuffix && (
            <span className="idm-price-suffix"> {product.priceSuffix[lang]}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
